const _isEmpty = (value: any): boolean => typeof value === 'undefined' || value === null || value === '' || /^\s+$/.test(value)

const _isDefined = (value: any): boolean => typeof value !== 'undefined' && value !== null

const required = (value: any): string | string [] => {
  if (process.env.EVENTS_DOC) {
    return [ 'Required' ]
  }

  if (_isEmpty(value)) {
    return 'required'
  }
}

const string = (value: string): string | string[] => {
  if (process.env.EVENTS_DOC) {
    return [ 'String' ]
  }

  if (_isDefined(value) && typeof value !== 'string') {
    return 'must be a string'
  }
}

const integer = (value: number): string | string[] => {
  if (process.env.EVENTS_DOC) {
    return [ 'Integer' ]
  }

  if (_isDefined(value) && (typeof value !== 'number' || !Number.isInteger(Number(value)))) {
    return 'must be a number'
  }
}

const number = (value: number): string | string[] => {
  if (process.env.EVENTS_DOC) {
    return [ 'Number' ]
  }

  if (_isDefined(value) && (typeof value !== 'number' || Number.isNaN(value))) {
    return 'must be a number'
  }
}

const bool = (value: boolean): string | string[] => {
  if (process.env.EVENTS_DOC) {
    return [ 'Boolean' ]
  }

  if (_isDefined(value) && typeof value !== 'boolean') {
    return 'expected boolean' // AIzaSyD2g_pRmevsNsKfN5dI2UY4LUKohQbIIi4
  }
}

const oneOf = (values: any[]) => (value: any): string | any[] => {
  if (process.env.EVENTS_DOC) {
    return [ 'One of', values ]
  }

  if (_isDefined(value) && !values.includes(value)) {
    return `expected one of ${JSON.stringify(values)}`
  }
}

type TypeValidator = (value: any) => string | string[]

const oneOfTypes = (typeValidators: TypeValidator[]) => {
  if (!Array.isArray(typeValidators)) {
    throw new Error('Wrong argument passed to oneOfTypes()')
  }

  return (value: any[]): string | any[] => {
    const types = typeValidators.map((typeValidator) => typeValidator.name)

    if (process.env.EVENTS_DOC) {
      return [ 'One of types', types ]
    }

    if (_isDefined(value)) {
      const isValid = typeValidators.some((typeValidator) => !typeValidator(value))

      if (!isValid) {
        return `expected one of types ${JSON.stringify(types)}`
      }
    }
  }
}

const arrayOf = (typeValidator: TypeValidator) => {
  if (typeof typeValidator !== 'function') {
    throw new Error('Wrong argument passed to oneOfTypes()')
  }

  return (value: any[]): string | any[] => {
    if (process.env.EVENTS_DOC) {
      return [ 'Array of', typeValidator.name ]
    }

    if (_isDefined(value)) {
      let isValid = Array.isArray(value)

      if (isValid) {
        isValid = value.every((item) => !typeValidator(item))
      }

      if (!isValid) {
        return `expected array of ${typeValidator.name}`
      }
    }
  }
}


export {
  _isEmpty,
  required,
  string,
  integer,
  bool,
  oneOf,
  oneOfTypes,
  arrayOf,
  number,
}
